export default __webpack_public_path__ + "static/media/dg-icon.baf33bd9.webp";